import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FormikSelectTwo from "../../../utils/Select";
import { EmailNoteList, EmailTemplateModuleList } from "../../../assets/data/CountryMini";
import { useParams } from "react-router-dom";
import { NuInput, NuTextArea } from "../../../utils/Inputs";

export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
}) {
  const {stdId} = useParams()
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [createNew, setCreateNew] = useState({
    standard_id:"",
    subject:"$title",
    message:"$subtitle",
    status_name:""
  });

  useEffect(() => {
    setCreateNew({
      subject: data?.subject,
      message: data?.message,
      standard_id: data?.standard_id,
      status_name: data?.status_name,
    });
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      value.standard_id = stdId
      if (data?.id) {
        editData({
          url: `/email_templates/${data?.id}`,
          value: value,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      } else {
        addData({
          url: `/email_templates/`,
          value: value,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      }
    },
  });

  const resetClose = () => {
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;



  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-30 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <FormikSelectTwo
                formik={formik}
                name="status_name"
                label="Status"
                width="w-full"
                placeholder="Select Status"
                Options={EmailTemplateModuleList}
                zindex={12}
                isDisabled={data ? true : false}
              />
              <NuInput
                formik={formik}
                name="subject"
                label="Subject"
                width="w-full"
                placeholder="Subject"
              />

              <NuTextArea
                formik={formik}
                name="message"
                label="Message"
                width="w-full"
                placeholder="Enter Message"
              />
                <div className="w-full px-6">
                  <p className=" text-[13px] font-medium mt-4 mb-1">Note : <span className=" text-xs font-normal text-gray-500 mb-2">Please use this keywords for the Email Template </span></p>
                  <table>
                    <tbody>
                      {
                        EmailNoteList.map((note, i) => (
                          <tr key={i}>
                            <td className="text-xs text-gray-500 w-[105px] py-0.5">{note.key}</td>
                            <td className="text-xs text-gray-500 w-[10px] py-0.5">:</td>
                            <td className="text-xs text-gray-500 py-0.5">{note.value}</td>
                          </tr>
                        )
                    )}
                    </tbody>
                  </table>
                </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
